import {usAllTerritoriesGeoJson} from '../bip/constants/MapUsAllTerritories.js'
import { SampleYearChoices, VirusDisplayAndKey } from './constants'

function render(config, year, virusField) {
  renderVirusMap(config, year, virusField)
}

$(function () {
  const config = JSON.parse(document.getElementById('config').textContent)
  // config.sampleYears has the latest year before there is any data for that year.
  // Therefore, getting available years from constants SampleYearChoices
  // .length -1 will return the last ellement in the array.
  const initial_year = SampleYearChoices[SampleYearChoices.length - 1];

  const initial_virus = 'dwv'



  render(config, initial_year, initial_virus)


  // onChange year picker logic.
  let $yearPicker = $('<select class="form-select"></select>')
  $('.year-picker').append($yearPicker)
  $yearPicker.append(SampleYearChoices.map(year => `<option value="${year}">${year}</option>`))
  $yearPicker.val(initial_year)
  $yearPicker.on('change', () => {
    let selectedYear = parseInt($yearPicker.val())
    let selectedVirus = $virusPicker.val()
    render(config, selectedYear, selectedVirus)
    // GA4 event code.
    gtag ('event', 'Sample_Year_Change', {
      'screen_name': 'virus_map2.html',
      'selected_year' : selectedYear,
      'selected_virus' : selectedVirus
    })
  })

  // onChange virus picker logic.
  let $virusPicker = $('<select class="form-select"></select>')
  $('.virus-picker').append($virusPicker)

  Object.entries(VirusDisplayAndKey).forEach(entry => {
    const [key, value] = entry;
    $virusPicker.append(`<option value="${value}">${key}</option>`)
  });

  $virusPicker.val(initial_virus)
  $virusPicker.on('change', () => {
    let selectedYear = parseInt($yearPicker.val())
    let selectedVirus = $virusPicker.val()
    render(config, selectedYear, selectedVirus)
    // GA4 event code.
    gtag ('event', 'Pathogens_Change', {
      'screen_name': 'virus_map2.html',
      'selected_year' : selectedYear,
      'selected_virus' : selectedVirus
    })
  })


})


// const perYear = year => x => x.year === year


// function filterByYear takes a parameter for the year to be tested/included then
// inside of filterByYear is another function that takes the array element (arrayElement)
// that is passed by .filter.
function filterByYear(testYear) {
  return function(arrayElement){
    if (arrayElement.year == testYear) {
      return true}
  }
}

// The filter() method creates a new array filled with elements that pass
// a test provided by a function.  Only if filterByYear returns TRUE will
// the original array element be put in the new array.
const virusStateDataPerYear = (config, year) =>
  config.yearVirusData.filter(filterByYear(year))


function percentOrNull(v) {
  return v[1] > 0 ? Math.round(v[0] / v[1] * 100) : null
};


function renderVirusMap(config, year, virusField) {
  const { state_reports_result_url } = config
  // virusStateDataPerYear will use .filter to get data to one year only.
  const data2 = virusStateDataPerYear(config, year)
  // .map will return only the data for one virus (data[virus identifier])
  const data = data2.map(s => {
    const data = s.data[virusField]
    return {
        name: s.state,
        year: s.year,
        value: percentOrNull(data),
        samples_n: data[1],
        viruses: virusField,
        sources_n: data[2],
        months: data[3]
    }
})


  // onClickPoint was working to open the state_report in a new page but we dont want
  // that report.  Could be adapted to open a new report. Also need "allowPointSelect: true"
  //function onClickPoint() {
    //const reportURI = constructURI(state_reports_result_url, { year, state: state_to_PC[this.name] })
    //window.open(reportURI, '_blank')
  //}

  // virusField passed is lowercase so s.data[virusField] gets correct data.  But we want to
  // display the uppercase version.  Also, DWV-A = s.data[dwv] and DWV-B = s.data[vdv]!
  const showKey = Object.keys(VirusDisplayAndKey).find(key => VirusDisplayAndKey[key] === virusField);


  // Highcharts code for VirusMap.
  Highcharts.mapChart('virusNationalMap', {
    title: {
      text: `${year} Prevalence of ${showKey}`
    },
    subtitle: {
      text: 'Number of honey bee samples and prevalence color gradient displayed per sampled state.'
    },
    chart: {
      height: 600,
      marginTop: 100,
    },
    responsive: {
      rules: [
        {
          chartOptions: {
            chart: {
              height: 500,
            },
          },
          condition: {
            maxWidth: 680
          }
        }
      ]
    },
    legend: {
      layout: 'horizontal',
      borderWidth: 0,
      // backgroundColor: 'rgba(255,255,255,0.85)',
      backgroundColor: '#e6e6e6',
      floating: true,
      verticalAlign: 'top',
      y: 50
    },
    mapNavigation: {
      buttonOptions: {
        alignTo: 'spacingBox'
      },
      enabled: true,
      enableMouseWheelZoom: false
    },
    colorAxis: {
      min: 1,

      stops: [
        // Green
        [0.0005, '#e7f8fd'],
         // Blue
        [0.15, '#9fd2f9'],
        [0.40, '#56b0f5'],
        // purple
        [0.77, '#5a0c41'],
        [0.90, '#430931'],
        [0.95, '#2d0621'],
        [1, '#160310']
      ]

    },
    plotOptions: {
      series: {
        nullColor: {
          pattern: {
            path: { d: 'M 0 28 L 28 0 M -4 4 L 4 -4 M 25 31 L 31 25',
                    strokeWidth: 9
            },
            color: '#b3b3b3',
            backgroundColor: '#cccccc',
            width: 28,
            height: 28,
            patternTransform: 'scale(10) rotate(90)'
          }
        },
      }
    },

    series: [{
      data: data,
      mapData: usAllTerritoriesGeoJson,
      // The joinBy option can also be an array of two values, where the first
      // points to a key in the mapData, and the second points to a key in the data.
      // joinBy: ['postalcode', 'state_code'],
      // postalcode is in Highcharts
      // state_code is in data and is the state abbreviation
      // in this case the Highcharts field and the data field are both "name".
      joinBy: ['name', 'name'],
      dataLabels: {
        allowOverlap: true,
        enabled: true,
        color: '#FFFFFF',
        // “format” accepts a string that will be displayed over the state on the map
        format: '{point.samples_n}',
        // filter: will hide dataLable if samples_n is 0.
        filter: {
          property: 'samples_n',
          operator: '>',
          value: 0
        }
      },
      name: 'Pathogen Prevalence',
      tooltip: {
        //  headerFormat: null,  this line would supress the name "Pathogen Prevalence"
        pointFormat: '<span>{point.name}</span> <br> {point.viruses}: {point.value}% <br> sample_n = {point.samples_n} <br> sources_n = {point.sources_n} <br> months = {point.months}'
      },
      allowPointSelect: false,
      point: {
        events: {
          //click: onClickPoint
        }
      }
    }]
  })
}



